module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_1.df0ab452.png";